<template>
  <div>
    <v-flex md4
     class="mx-auto"
     color="secondary"
     width="200px"
    >
      <v-layout align-baseline>
        <v-text-field
          :placeHolder="$t('email')"
          name="email"
          id="email"
          :loading='isLoading'
          clearable
          v-model="email">
        </v-text-field>
        <v-btn flat color="primary" title="Search" @click="searchEmail">
          {{ $t('search') }}
        </v-btn>
      </v-layout>
    </v-flex>
    <v-toolbar flat color="white">
    </v-toolbar>
    <v-data-table
      :headers="tableTitles"
      :items="userList"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <td>{{ props.item.name }}</td>
        <td class="text-xs-left">{{ props.item.email }}</td>
        <td class="text-xs-left">{{ props.item.role | convertNumToRole({ isAdminStaff:props.item.isAdminStaff,organization:props.item.organization,warehouse:props.item.warehouse})}}</td>
        <td class="text-xs-left">{{ props.item.organization }}</td>
        <td class="text-xs-left">{{ props.item.warehouse }}</td>
        <td class="text-xs-left">{{ props.item.workfor }}</td>
        <td class="text-xs-left">{{ props.item.isAdminStaff }}</td>
        <td class="text-xs-left">{{ createTime }}</td>
        <td class="justify-left layout px-0">
          <v-btn :loading='isDeleting' flat small icon @click="deleteTargetUser(props.item)" v-if="isShowDeleteButton">
            <v-icon>delete</v-icon>
          </v-btn>
        </td>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import {queryWithPredicatesStore} from '@/utils/dbAccessor'
import { toTimestampString } from '@/utils/tools'
export default {
  data () {
    return {
      showDialog: false,
      isLoading: false,
      email: '',
      tableTitles: [
        {
          text: this.$t('userName'),
          align: 'left',
          sortable: false,
          value: 'name',
          width: '300px'
        },
        { text: this.$t('email'), value: 'email', width: '10%' },
        { text: this.$t('role'), value: 'role', width: '10%' },
        { text: this.$t('organization'), value: 'organization', width: '10%' },
        { text: this.$t('warehouse'), value: 'warehouse', width: '10%' },
        { text: this.$t('workFor'), value: 'workfor', width: '10%' },
        { text: this.$t('isAdminStaff'), value: 'isAdminStaff', width: '10%' },
        { text: this.$t('registTime'), value: 'createTime', width: '10%' },
        { text: this.$t('actions'), value: 'name', sortable: false, width: '8%' }
      ],
      userList: [],
      isDeleting: false
    }
  },
  computed: {
    cacheQueriedItem () {
      return this.userList[0]
    },
    isShowDeleteButton () {
      return !this.cacheQueriedItem.organization && !this.cacheQueriedItem.warehouse && !this.cacheQueriedItem.workfor && !this.cacheQueriedItem.isAdminStaff
    },
    createTime () {
      return this.cacheQueriedItem.createTime && this.cacheQueriedItem.createTime.seconds ? toTimestampString(new Date(this.cacheQueriedItem.createTime.seconds * 1000)) : ''
    }
  },
  watch: {},
  methods: {
    async searchEmail () {
      const result = await this.getTargetUserInfo()
      this.userList = result
    },
    async getTargetUserInfo () {
      let predicates = [{
        'field': 'email',
        'compare': '==',
        'value': this.email
      }]
      const result = await queryWithPredicatesStore(predicates, 'users')
      return [
        ...result.docs.map(doc => {
          let docInfo = doc.data()
          return {
            name: docInfo.name,
            email: docInfo.email,
            role: docInfo.role,
            uid: doc.id,
            warehouse: docInfo.warehouses && docInfo.warehouses.join(),
            organization: docInfo.organizations && docInfo.organizations.join(),
            workfor: docInfo.workfor,
            isAdminStaff: docInfo.isAdminStuff || false,
            createTime: docInfo.createTime
          }
        })
      ]
    },
    async deleteTargetUser () {
      this.isDeleting = true
      try {
        if (confirm(this.$t('confirmDeleteUser'))) {
          let result = await this.$store.dispatch('deleteTargetUser', this.cacheQueriedItem.uid)
          this.$store.dispatch('showToast', {info: result.data, level: 'success'})
          this.userList = this.userList.filter(item => item.uid !== this.cacheQueriedItem.uid)
          this.isDeleting = false
        }
      } catch (error) {
        this.isDeleting = false
        this.$store.dispatch('showToast', {info: error.message, level: 'error'})
        console.log(error)
      }
    }
  },
  filters: {
    convertNumToRole (num, userInfo) {
      const {isAdminStaff, organization, warehouse} = userInfo
      let role = {
        '0': 'organization',
        '1': 'individual',
        '2': 'warehouse'
      }
      return num === 1 && (isAdminStaff === true || organization || warehouse) ? 'staff' : role[num]
    }
  }
}
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/UserSettings.vue